import {AuditTrail, Signature} from "./signatures";

export enum SignatureTypes {
    GRAPHIC = "graphic",
    NONE = "none",
    FULLNAME_DATE = "fullname_date",
    INITIALS_DATE = "initials_date",
}

export interface PdfSignature extends Signature {
    signerFullname: string;
    signatureType: SignatureTypes;
    otpSms?: string;
    isForensic?: boolean;
}

export interface AesSignature extends PdfSignature {
    aesProviderId: number;
}

export interface PdfSignatureFull extends PdfSignature {
    attachedFiles?: {
        xml: {
            url: string;
            size: number;
        },
        documents: {
            name: string;
            url: string;
            size: number;
        }[],
        signedDocuments: {
            name: string;
            url: string;
            size: number;
        }[],
    };
    auditTrailXML?: string;
    auditTrail?: AuditTrail;
}

export interface AesSignatureFull extends PdfSignatureFull, AesSignature {}

export interface PdfSignatureState {
    signatures?: PdfSignature[];
    json?: object;
    total: number;
}

export interface AesSignatureState {
    signatures?: AesSignature[];
    total: number;
    json?: object;
}
